import { useTranslation } from 'react-i18next';
import { FaGithub, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-12 px-4 sm:px-6 lg:px-8 transition-colors duration-200" style={{backgroundColor: 'var(--card)', color: 'var(--card-foreground)'}}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <a href="#" className="text-xl font-bold gradient-text">{t('footer.brand')}</a>
            <p className="text-gray-400 mt-2">{t('footer.tagline')}</p>
          </div>
          <div className="flex space-x-6">
            <a href="https://github.com/ismailfreelance" target="_blank" className="text-gray-400 hover:text-white transition duration-300" aria-label={t('common.social.github')}>
              <FaGithub className="text-xl" />
            </a>
            <a href="https://x.com/ismailfreelance" target="_blank" className="text-gray-400 hover:text-white transition duration-300" aria-label={t('common.social.twitter')}>
              <FaTwitter className="text-xl" />
            </a>
            <a href="https://www.linkedin.com/in/ismail-dev" target="_blank" className="text-gray-400 hover:text-white transition duration-300" aria-label={t('common.social.linkedin')}>
              <FaLinkedinIn className="text-xl" />
            </a>
            <a href="https://www.instagram.com/ismailfreelance/" target="_blank" className="text-gray-400 hover:text-white transition duration-300" aria-label={t('common.social.instagram')}>
              <FaInstagram className="text-xl" />
            </a>
          </div>
        </div>
        <div className="border-t mt-8 pt-8 flex flex-col md:flex-row justify-between items-center" style={{borderColor: 'var(--border)'}}>
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            {t('footer.copyright')}
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition duration-300">{t('common.status.privacyPolicy')}</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition duration-300">{t('common.status.termsOfService')}</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition duration-300">{t('common.status.cookiesPolicy')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
